import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useDebugValue } from "react";
import { inBrowser } from "@lilib/utils";
import useSafeState from "./useSafeState";
import useEventListener from "./useEventListener";
function useWindowFocus() {
  var _useSafeState = useSafeState(function () {
      if (inBrowser) {
        return document.hasFocus();
      } else {
        return false;
      }
    }),
    _useSafeState2 = _slicedToArray(_useSafeState, 2),
    focus = _useSafeState2[0],
    setFocus = _useSafeState2[1];
  useEventListener(function () {
    return window;
  }, "focus", function () {
    setFocus(true);
  });
  useEventListener(function () {
    return window;
  }, "blur", function () {
    setFocus(false);
  });
  useDebugValue(focus);
  return focus;
}
export default useWindowFocus;